// Core
import { Map } from 'immutable';
import { handleActions } from 'redux-actions';

// Instruments
import { uiActions as actions } from './actions';

const initialState = Map({
    selectedCurrency:    'uah',
    availableCurrencies: ['uah'],
    modals:              Map({
        orderSimple: false,
    }),
});

export const uiReducer = handleActions({
    [actions.setSelectedCurrency]: (state, { payload: currency }) => {
        return state.set('selectedCurrency', currency);
    },
    [actions.setAvailableCurrencies]: (state, { payload: currencies }) => {
        return state.set('availableCurrencies', currencies);
    },
    [actions.setModalStatus]: (state, { payload: { modal, status }}) => {
        return state.setIn(['modals', modal], status);
    },
}, initialState);
